import script from "./GiftPackagingDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiftPackagingDialog.vue?vue&type=script&lang=ts&setup=true"

import "./GiftPackagingDialog.vue?vue&type=style&index=0&id=3873d046&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3873d046"]])

export default __exports__